import { SendImportDocumentsUI } from './sendImportDocumentsUI'
import { useSendDocuments } from '../../hooks/useSendDocuments/useSendDocuments'

function SendImportDocuments() {
  const props = useSendDocuments()
  return <SendImportDocumentsUI {...props} />
}

export default SendImportDocuments